import { put, select, takeLatest } from 'redux-saga/effects'

import { SET_ACTIVE_FLOOR } from '../../../actions/drawable'
import { selectKeyboardMultiSelectedItems, setKeyboardMultiSelectedItems } from '../../slices/2D'

export function* handleClearKeyboardSelectionOnPageChange() {
    const keyboardMultiSelectedItems: number[] | null = yield select(selectKeyboardMultiSelectedItems)

    if (!keyboardMultiSelectedItems?.length) return

    yield put(setKeyboardMultiSelectedItems(null))
}

export function* watchForClearKeyboardSelectionOnPageChange() {
    yield takeLatest(SET_ACTIVE_FLOOR, handleClearKeyboardSelectionOnPageChange)
}
